var exports = {
  "az": "Box__mFXfRG",
  "EY": "Text__c9dCxn",
  "UE": "Text_1__nwBgm_",
  "wy": "Box_1__AUbm2z",
  "$n": "Button__qMqGmf",
};

module.exports = exports;
